/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum CaseNoticeType {
  AV_NOTICE_OF_INTENT = 'av_notice_of_intent',
  AV_NOTICE_OF_DEPARTMENT_DECISION = 'av_notice_of_department_decision',
  AV_FINAL_DETERMINATION = 'av_final_determination',
  NOTICE_OF_HEARING = 'notice_of_hearing',
  MC_NOTICE_OF_DEPARTMENT_DECISION = 'mc_notice_of_department_decision',
  MC_LETTER_OF_WARNING = 'mc_letter_of_warning',
  MC_FINAL_ORDER = 'mc_final_order',
  MC_AGREED_FINAL_ORDER = 'mc_agreed_final_order',
  MC_DPS_UNSAT_CLOSURE_LETTER = 'mc_dps_unsat_closure_letter',
  FIRST_DEMAND_LETTER = 'first_demand_letter',
  FINAL_DEMAND_LETTER = 'final_demand_letter',
}
